export default __webpack_public_path__ + "static/media/Ballroll_00279.8c737bb4.png";